import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import MessageType from "../../../../utils/MessageType";
import { handleErrorMessage } from "../../../../utils/Utils";

interface ReviewDecideServiceType {}

const ACCEPT_STATUS = "accept";

const DECLINE_STATUS = "decline";

export default function ReviewDecideService(): ReviewDecideServiceType {
  const { showMessage } = useAppContext();

  const { articleID, articleReviewerId, status }: any = useParams();

  const history = useHistory();

  const { axiosPostAcceptDeclineArticle }: ArticleControllerType = ArticleController();

  const statusValue = () => {
    if (status === ACCEPT_STATUS) return true;
    if (status === DECLINE_STATUS) return false;
  };

  useEffect(() => {
    axiosPostAcceptDeclineArticle(articleID, articleReviewerId, statusValue())
      .then((response: any) => {
        if (status === ACCEPT_STATUS) {
          showMessage("Review is successfully accepted.", MessageType.SUCCESS);
          history.push(`/${articleID}/review/${articleReviewerId}`);
        } else if (status === DECLINE_STATUS) {
          showMessage("Review is successfully declined.", MessageType.SUCCESS);
          history.push(`/reviewerToDoList`);
        }
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
}

export type { ReviewDecideServiceType };
